import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledFlex = styled(Flex)`
    border-right: 1px solid #e8e8e8;
    padding-right: 48px;
    align-self: stretch;
    max-height: 240px;
    overflow-y: auto;
`;
